import React from 'react';
import { Input, InputProps } from './input';
import { Textarea, TextareaProps } from './textarea';
import { getDirAttribute, getRTLClasses } from '../../utils/rtl';
import { cn } from '../../lib/utils';

interface RTLInputProps extends InputProps {
  language: string;
}

interface RTLTextareaProps extends TextareaProps {
  language: string;
}

/**
 * RTL-aware Input component that automatically adjusts direction and alignment
 * based on the selected language
 */
export const RTLInput = React.forwardRef<HTMLInputElement, RTLInputProps>(
  ({ language, className, ...props }, ref) => {
    const rtlClasses = getRTLClasses(language);
    const dirAttribute = getDirAttribute(language);
    
    return (
      <Input
        ref={ref}
        dir={dirAttribute}
        className={cn(rtlClasses.className, className)}
        {...props}
      />
    );
  }
);

RTLInput.displayName = 'RTLInput';

/**
 * RTL-aware Textarea component that automatically adjusts direction and alignment
 * based on the selected language
 */
export const RTLTextarea = React.forwardRef<HTMLTextAreaElement, RTLTextareaProps>(
  ({ language, className, ...props }, ref) => {
    const rtlClasses = getRTLClasses(language);
    const dirAttribute = getDirAttribute(language);
    
    return (
      <Textarea
        ref={ref}
        dir={dirAttribute}
        className={cn(rtlClasses.className, className)}
        {...props}
      />
    );
  }
);

RTLTextarea.displayName = 'RTLTextarea'; 